import Css from "./style.module.scss";

import { Select } from "nlib/ui";
import { getAllUsersData } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import OrganizationsActions from "actions/OrganizationsActions";
import React, { useCallback, useMemo } from "react";
import UiActions from "actions/UiActions";
import UserRoles from "const/UserRoles";
import getUserEmailOptionLabel from "../../../getUserEmailOptionLabel";

const ADD_NEW_CLIENT_OPTION_VALUE = "+";

const SelectAskPerson = ({ value, disabled, businessId, onChange, ...restProps }) => {
  const dispatch = useDispatch();

  const { uiTexts } = useSelector(getTextsData);

  const usersData = useSelector(getAllUsersData);

  const businessUsers = useMemo(() => {
    return usersData
      .filter(({ role, businessIds = [] }) => UserRoles.checkIsBusiness(role) && businessIds.includes(businessId))
      .filter(({ email }) => !!email);
  }, [businessId, usersData]);

  const groups = useMemo(() => {
    return [
      { value: "0" },
      { value: "1", label: uiTexts.users }
    ];
  }, [uiTexts]);

  const options = useMemo(() => {
    return [
      { value: ADD_NEW_CLIENT_OPTION_VALUE, label: `+ ${uiTexts.inviteUser}`, group: "0" },
      ...(businessUsers.map((user) => ({
        value: user.email.toLowerCase(),
        label: getUserEmailOptionLabel(user),
        group: "1"
      })))
    ];
  }, [uiTexts.inviteUser, businessUsers]);

  const handleChange = useCallback(async(newValue) => {
    if (newValue === ADD_NEW_CLIENT_OPTION_VALUE) {
      const result = await dispatch(UiActions.showAskClientWindow({ noPhone: true }));

      if (!result) return;

      const { userEmail, invite } = result;

      if (userEmail) {
        if (invite) {
          await dispatch(OrganizationsActions.inviteUser({
            email: userEmail,
            role: UserRoles.BUSINESS_MANAGER.roleId,
            businessIds: [businessId]
          }));
        }
        await dispatch(OrganizationsActions.askBusinessUser([], userEmail, false, false, true));
        await dispatch(OrganizationsActions.fetchUsersList(true, true));
        onChange(result.userEmail);
      }
    } else {
      onChange(newValue);
    }
  }, [businessId, dispatch, onChange]);

  return (
    <div className={Css.selectAskPerson}>
      <Select
        options={options}
        groups={groups}
        value={value}
        invalid={!value}
        className={Css.input}
        buttonClassName={Css.button}
        disabled={disabled}
        placeholder={uiTexts.selectPersonEmail}
        onChange={handleChange}
        {...restProps} />
    </div>
  );
};

export default React.memo(SelectAskPerson);
